// extracted by mini-css-extract-plugin
export default {"wrapper":"imageView_wrapper__1XZ7X"};